import React from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { Link } from 'site-modules/shared/components/link/link';
import { isNewState } from 'client/site-modules/shared/utils/publication-states';
import {
  generateSrpLinkMakeModel,
  generateSrpLinkNewMakeModel,
  srpLinkBuilder,
} from 'site-modules/shared/utils/srp-link-constructor';
import { DEALERLESS_OEM } from 'site-modules/shared/constants/oem';

export function SrpButton({ makeSlug, modelSlug, year, publicationState, makeName, modelName }) {
  const newVehicleLink = DEALERLESS_OEM.includes(makeSlug)
    ? generateSrpLinkMakeModel(makeSlug, modelSlug)
    : generateSrpLinkNewMakeModel(makeSlug, modelSlug);
  const inventoryLink = isNewState(publicationState)
    ? newVehicleLink
    : srpLinkBuilder({ inventorytype: 'used', make: makeSlug, model: modelSlug, radius: '100', year });

  const ymmName = `${year} ${makeName} ${modelName}`;
  const labelName =
    isNewState(publicationState) && DEALERLESS_OEM.includes(makeSlug) ? 'See Used for Sale' : 'See all for sale';

  return (
    <Button
      tag={Link}
      size="lg"
      color="primary-b"
      to={inventoryLink}
      className="text-transform-none fw-normal px-1 py-0_5"
      data-tracking-id="srp_link"
      data-tracking-parent="comparator-srp-link"
      aria-label={`${labelName} for ${ymmName}`}
    >
      {labelName}
    </Button>
  );
}

SrpButton.propTypes = {
  makeSlug: PropTypes.string,
  modelSlug: PropTypes.string,
  year: PropTypes.number,
  publicationState: PropTypes.string,
  makeName: PropTypes.string,
  modelName: PropTypes.string,
};

SrpButton.defaultProps = {
  makeSlug: null,
  modelSlug: null,
  year: null,
  publicationState: null,
  makeName: null,
  modelName: null,
};
